import angular from 'angular';

import CaseModel from '../../models/case';
import StatusRow from '../../directives/status-message/status-row';

import AccountSetupCtrl from './account-setup.controller';
import AccountSetupModalConf from './account-setup.config';

export default angular.module('app.account-setup', [CaseModel, StatusRow])
	.controller('AccountSetupCtrl', AccountSetupCtrl)
	.constant('AccountSetupModalConf', AccountSetupModalConf)
	.name;



// WEBPACK FOOTER //
// ./project/modals/account-setup/index.js